export default "__VITE_ASSET__Bp$RuzIL__"